import { FilteredFacet } from "@/apiUtils/algoliaUtils/types";
import SiteInfo from "./SiteInfo";
import IconInfo from "@/assets/icons/info.svg?react";

export interface IProps {
  lang: string;
  selectedTab: string;
  tabs: FilteredFacet[];
  searchParams: Record<string, string>;
  onSelect: (tab: string) => void;
}

const FilterTabs = ({ lang, tabs, selectedTab, searchParams, onSelect }: IProps) => {
  return (
    <div className="flex flex-col bg-tertiary-7">
      {tabs?.map((tab, index) => {
        // URL key comes only from Sanity filterParams — no static lookup
        const tabKey = tab?.filterParams;
        let tabUsed =
          (tabKey && searchParams?.hasOwnProperty(tabKey)) ||
          (tab?.type === "price" &&
            searchParams?.hasOwnProperty("pmin") &&
            searchParams?.hasOwnProperty("pmax"));

        if (!tabUsed && tab?.isBooleanGroup && Array.isArray(tab?.booleanMappings)) {
          tabUsed = tab.booleanMappings.some(
            (mapping) => mapping.filterParams && searchParams?.hasOwnProperty(mapping.filterParams)
          );
        }

        return (
          <div key={index} className="relative border-b-[1px]">
            <button
              onClick={() => onSelect(tab?.type)}
              className={`flex w-full items-center justify-start py-6 ps-[18px] text-left text-sm ${selectedTab === tab?.type ? "bg-white" : ""} `} //${tab.tab === "Sale" ? "font-semibold text-secondary-1" : ""}
            >
              <span className="min-w-0 flex-1 text-left">{tab?.name?.[lang] || ""}</span>
              <SiteInfo tab={tab} lang={lang} position="bottom">
                <span className="information ml-1" id={`${tab.type}Tooltip`}>
                  <IconInfo height={15} width={15} />
                </span>
              </SiteInfo>
            </button>
            {tabUsed && <div className="let-0 absolute top-0 h-full w-1 bg-primary-1" />}
          </div>
        );
      })}
    </div>
  );
};

export default FilterTabs;